<style scoped>
    .sort-item {
        padding: 3px 0;
    }
</style>

<template>
    <div>
        <cp-checkable-item type="radio" class="sort-item" v-model="passThroughValue" value="popular">
            Popular this week
        </cp-checkable-item>
        <cp-checkable-item type="radio" class="sort-item" v-model="passThroughValue" value="closest">
            Closest to goal
        </cp-checkable-item>
        <cp-checkable-item type="radio" class="sort-item" v-model="passThroughValue" value="amount">
            Most funds raised
        </cp-checkable-item>
        <cp-checkable-item type="radio" class="sort-item" v-model="passThroughValue" value="updated">
            Recently updated
        </cp-checkable-item>
    </div>
</template>

<script>
    import CpCheckableItem from './checkable-item';

    export default {
        components: {
            CpCheckableItem,
        },

        props: {
            value: String,
        },

        computed: {
            passThroughValue: {
                get() {
                    return this.value;
                },

                set(passThroughValue) {
                    this.$emit('input', passThroughValue);
                },
            },
        },
    };
</script>
